/*theme.js*/
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Reveal on scroll
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => e.isIntersecting && e.target.classList.add('is-visible'));
  }, { threshold: 0.12 });
  const observeReveals = (root = document) => {
    if (root.matches?.('.reveal') && !root.classList.contains('is-visible')) io.observe(root);
    (root.querySelectorAll ? root.querySelectorAll('.reveal:not(.is-visible)') : []).forEach((el) => io.observe(el));
  };
  observeReveals();
  // Keep watching for new .reveal elements added later (editor AJAX section swaps, dynamic content)
  const mo = new MutationObserver((mutations) => {
    mutations.forEach((m) => m.addedNodes.forEach((node) => { if (node.nodeType === 1) observeReveals(node); }));
  });
  mo.observe(document.body, { childList: true, subtree: true });
  // Also re-scan explicitly when the Shopify theme editor swaps/reorders sections
  document.addEventListener('shopify:section:load', (e) => observeReveals(e.target));
  document.addEventListener('shopify:section:reorder', () => observeReveals());
  document.addEventListener('shopify:section:select', () => observeReveals());

  // Header + announcement bar: the bar scrolls away normally; the header tracks it and settles at the very top once it's gone (or dismissed)
  const header = $('.site-header');
  const bar = $('[data-announcement-bar]');
  const closeBtn = $('[data-announcement-close]');

  const getBarHeight = () => (bar && !bar.classList.contains('is-hidden') ? bar.offsetHeight : 0);

  const updateHeaderPosition = () => {
    if (!header) return;
    const barHeight = getBarHeight();
    const top = Math.max(0, barHeight - window.scrollY);
    header.style.top = `${top}px`;
    const scrolled = window.scrollY > Math.max(0, barHeight - 4);
    header.classList.toggle('is-scrolled', scrolled);
    document.body.classList.toggle('is-scrolled', scrolled);
  };

    if (bar) {
    try {
      if (sessionStorage.getItem('ciella_announcement_dismissed') === '1') {
        bar.classList.add('is-hidden');
      }
    } catch {}
    closeBtn?.addEventListener('click', () => {
      bar.classList.add('is-hidden');
      try { sessionStorage.setItem('ciella_announcement_dismissed', '1'); } catch {}
      updateHeaderPosition();
    });
  }

    updateHeaderPosition();
  window.addEventListener('scroll', updateHeaderPosition, { passive: true });
  window.addEventListener('resize', updateHeaderPosition);

    // Cookie consent banner — wired to Shopify's own Customer Privacy / consent-tracking API,
  // so Aceitar/Rejeitar actually records real consent (not just a cosmetic localStorage flag).
  // Shopify's own default banner must be removed in Admin (Settings > Customer privacy > Cookie banner)
  // for this one to be the only banner shown.
  const cookieBanner = $('#CookieBanner');
  const CONSENT_KEY = 'ciella_cookie_choice';
  const getSavedChoice = () => {
    try { if (localStorage.getItem(CONSENT_KEY)) return true; } catch (e) {}
    return document.cookie.split('; ').some((c) => c.indexOf(CONSENT_KEY + '=') === 0);
  };
  const saveChoice = (value) => {
    try { localStorage.setItem(CONSENT_KEY, value); } catch (e) {}
    document.cookie = `${CONSENT_KEY}=${value}; max-age=31536000; path=/; SameSite=Lax`;
  };
  if (cookieBanner && !getSavedChoice() && window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) return;
      const privacy = window.Shopify.customerPrivacy;
      if (!privacy || !privacy.shouldShowBanner()) return;

      cookieBanner.classList.add('is-visible');
      requestAnimationFrame(() => requestAnimationFrame(() => cookieBanner.classList.add('is-shown')));

      const hideBanner = () => {
        cookieBanner.classList.remove('is-shown');
        setTimeout(() => cookieBanner.classList.remove('is-visible'), 500);
      };
      const choose = (accepted) => {
        saveChoice(accepted ? 'accepted' : 'rejected');
        hideBanner();
        privacy.setTrackingConsent(
          { analytics: accepted, marketing: accepted, preferences: accepted, sale_of_data: accepted },
          (err) => { if (err) console.warn('Ciella: erro ao gravar consentimento no Shopify', err); }
        );
      };
      cookieBanner.querySelector('[data-cookie-accept]')?.addEventListener('click', () => choose(true));
      cookieBanner.querySelector('[data-cookie-reject]')?.addEventListener('click', () => choose(false));
    });
  }

  // Rotating "featured collection" product grid
  $$('.product-grid[data-rotate="true"]').forEach((grid) => {
    const dataScript = document.getElementById(`${grid.id}-data`);
    if (!dataScript) return;
    let products;
    try { products = JSON.parse(dataScript.textContent); } catch { return; }
    const cards = Array.from(grid.children).filter((el) => el.classList.contains('product-card'));
    if (!products || !products.length || !cards.length) return;

    const seconds = parseInt(grid.dataset.interval, 10);
    const intervalMs = (isNaN(seconds) ? 6 : seconds) * 1000;
    let offset = cards.length; // start rotating in from where the initial grid left off

    cards.forEach((card) => { card.style.transition = 'opacity .4s ease'; });

    setInterval(() => {
      cards.forEach((card) => {
        const p = products[offset % products.length];
        offset += 1;
        card.style.opacity = '0';
        setTimeout(() => {
          const img = card.querySelector('img');
          const title = card.querySelector('.product-card__title');
          const price = card.querySelector('.product-card__price');
          if (img && p.image) { img.src = p.image; img.alt = p.alt; }
          if (title) title.textContent = p.title;
          if (price) price.textContent = p.price;
          card.href = p.url;
          card.style.opacity = '1';
        }, 400);
      });
    }, intervalMs);
  });
  // Filter/sort drawer
  const filterDrawer = $('#FilterDrawer');
  if (filterDrawer) {
    const openFilter = () => { filterDrawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const closeFilter = () => { filterDrawer.classList.remove('is-open'); document.body.style.overflow = ''; };
    $$('[data-filter-open]').forEach((b) => b.addEventListener('click', openFilter));
    $$('[data-filter-close]').forEach((b) => b.addEventListener('click', closeFilter));
  }

  // Cart drawer
  const drawer = $('#CartDrawer');
  const openers = $$('[data-cart-open]');
  const closers = $$('[data-cart-close]');
  const openDrawer = () => { drawer?.classList.add('is-open'); document.body.style.overflow = 'hidden'; refreshCart(); };
  const closeDrawer = () => { drawer?.classList.remove('is-open'); document.body.style.overflow = ''; };
  openers.forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); openDrawer(); }));
  closers.forEach((b) => b.addEventListener('click', closeDrawer));

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      renderCart(cart);
      updateCount(cart.item_count);
    } catch {}
  }

  function money(cents) {
    return (cents / 100).toLocaleString('pt-PT', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
  }

  function renderCart(cart) {
    const items = $('#CartItems');
    const footer = $('#CartFooter');
    if (!items) return;
    if (!cart.items || cart.items.length === 0) {
      items.innerHTML = '<div class="cart-empty">O seu carrinho está vazio</div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    if (footer) footer.style.display = '';
    items.innerHTML = cart.items.map((it) => `
      <div class="cart-line" data-key="${it.key}">
        <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1') : ''}" alt="${it.product_title}">
        <div>
          <div class="cart-line__title">${it.product_title}</div>
          <div class="cart-line__meta">${it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : ''}</div>
          <div class="cart-line__qty">
            <button data-qty="-1" aria-label="Diminuir">−</button>
            <span>${it.quantity}</span>
            <button data-qty="1" aria-label="Aumentar">+</button>
          </div>
          <button class="cart-line__remove" data-remove>Remover</button>
        </div>
        <div class="cart-line__title">${money(it.final_line_price)}</div>
      </div>
    `).join('');
    $('#CartSubtotal').textContent = money(cart.total_price);

    $$('.cart-line', items).forEach((line) => {
      const key = line.dataset.key;
      line.querySelectorAll('[data-qty]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const delta = parseInt(btn.dataset.qty, 10);
          const current = parseInt(line.querySelector('span').textContent, 10);
          await changeCart(key, Math.max(0, current + delta));
        });
      });
      line.querySelector('[data-remove]')?.addEventListener('click', () => changeCart(key, 0));
    });
  }

  async function changeCart(id, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id, quantity }),
    });
    const cart = await res.json();
    renderCart(cart); updateCount(cart.item_count);
  }

  function updateCount(n) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

    // Wishlist — stored locally in this browser (no account/backend needed)
  const WISHLIST_KEY = 'ciella_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch {}
  }
  function toggleWishlist(handle) {
    const list = getWishlist();
    const i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    saveWishlist(list);
    return list;
  }
  function syncWishlistUI() {
    const list = getWishlist();
    $$('[data-wishlist-toggle]').forEach((btn) => {
      btn.classList.toggle('is-active', list.indexOf(btn.dataset.productHandle) > -1);
    });
    $$('[data-wishlist-count]').forEach((el) => {
      el.textContent = list.length;
      el.style.display = list.length > 0 ? '' : 'none';
    });
  }
  syncWishlistUI();
  // Only animate the heart after the first paint, so saved hearts don't "fill" on page load
  requestAnimationFrame(() => requestAnimationFrame(() => document.documentElement.classList.add('wl-ready')));
  // Track whether the last interaction was a finger/pen (covers hybrid devices like the Surface)
  const setTouchMode = (on) => document.documentElement.classList.toggle('using-touch', on);
  setTouchMode(window.matchMedia('(hover: none) and (pointer: coarse)').matches);
  document.addEventListener('pointerdown', (e) => setTouchMode(e.pointerType === 'touch' || e.pointerType === 'pen'), { passive: true, capture: true });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(btn.dataset.productHandle);
    syncWishlistUI();
    document.dispatchEvent(new CustomEvent('wishlist:change'));
  });

 // Product card color swatches: click to preview that color's image
// Preload every swatch image up front so the swap on click is instant,
// instead of only starting the download at the moment of the click.
const swatchImageCache = {};
function preloadSwatchImage(src) {
  if (!src || swatchImageCache[src]) return;
  const im = new Image();
  im.src = src;
  swatchImageCache[src] = im;
}
$$('[data-swatch]').forEach((el) => preloadSwatchImage(el.dataset.swatchImg));

document.addEventListener('click', (e) => {
  const swatch = e.target.closest('[data-swatch]');
  if (!swatch) return;
  e.preventDefault();
  e.stopPropagation();
  const card = swatch.closest('[data-product-card]');
  if (!card) return;
  const img = card.querySelector('[data-product-card-img]');
  const newSrc = swatch.dataset.swatchImg;
  if (img && newSrc && img.src !== newSrc) {
    const media = img.closest('.product-card__media');
    const clone = img.cloneNode(true);
    clone.classList.add('product-card__img--crossfade');
    clone.removeAttribute('data-product-card-img');
    clone.style.opacity = '';
    clone.src = newSrc;
    media.appendChild(clone);
    requestAnimationFrame(() => { clone.classList.add('is-visible'); });
    clone.addEventListener('transitionend', () => {
      img.src = newSrc;
      clone.remove();
    }, { once: true });
  }
  card.querySelectorAll('[data-swatch]').forEach((el) => el.classList.remove('is-active'));
  swatch.classList.add('is-active');
});


  // Product gallery: arrows, thumbnails, swipe
  $$('[data-gallery-main]').forEach((main) => {
    const track = main.querySelector('[data-gallery-track]');
    const slides = Array.from(main.querySelectorAll('[data-gallery-slide]'));
    const gallery = main.closest('.product__gallery');
    const thumbs = gallery ? Array.from(gallery.querySelectorAll('[data-gallery-thumb]')) : [];
    let index = 0;

    const goTo = (i) => {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      thumbs.forEach((t, ti) => t.classList.toggle('is-active', ti === index));
      slides.forEach((s, si) => {
        const v = s.querySelector('video');
        if (v && si !== index) v.pause();
      });
    };

    // Group photos by colour: each colour starts at its variant's featured photo
    const isMobileGallery = () => window.matchMedia('(max-width: 899px)').matches;
    const colorGroups = {};
    try {
      const vData = JSON.parse(document.getElementById('ProductVariants')?.textContent || '[]');
      const optNames = (vData[0] && vData[0].optionNames) || [];
      const cIdx = optNames.findIndex((n) => ['cor', 'color', 'colour'].includes(String(n).toLowerCase()));
      if (cIdx > -1) {
        const starts = [];
        vData.forEach((v) => {
          const c = v.options[cIdx];
          if (!v.featuredMediaId || starts.some((s) => s.color === c)) return;
          const si = slides.findIndex((s) => s.dataset.mediaId == v.featuredMediaId);
          if (si > -1) starts.push({ color: c, i: si });
        });
        starts.sort((a, b) => a.i - b.i);
        slides.forEach((s, si) => {
          let owner = starts[0];
          starts.forEach((st) => { if (st.i <= si) owner = st; });
          if (owner) (colorGroups[owner.color] = colorGroups[owner.color] || []).push(si);
        });
      }
    } catch (e) {}
    let allowed = slides.map((_, i) => i);
    main.setColor = (color) => {
      const g = colorGroups[color];
      allowed = g && g.length ? g : slides.map((_, i) => i);
      thumbs.forEach((t, ti) => t.classList.toggle('is-color-hidden', !allowed.includes(ti)));
    };
    const step = (dir) => {
      if (!isMobileGallery()) return goTo(index + dir);
      const pos = allowed.indexOf(index);
      goTo(pos === -1 ? allowed[0] : allowed[(pos + dir + allowed.length) % allowed.length]);
    };

    main.querySelector('[data-gallery-prev]')?.addEventListener('click', () => step(-1));
    main.querySelector('[data-gallery-next]')?.addEventListener('click', () => step(1));
    thumbs.forEach((t, ti) => t.addEventListener('click', () => goTo(ti)));

        // Allow the variant selector to jump this gallery to a specific media id.
    // A slide-through would cross every image in between and look like a delay,
    // so this crossfades straight to the target image instead.
    main.goToMedia = (mediaId) => {
      const i = slides.findIndex((s) => s.dataset.mediaId == mediaId);
      if (i < 0 || i === index) return;
      const targetImg = slides[i].querySelector('img');
      if (!targetImg) { goTo(i); return; }
      const clone = targetImg.cloneNode(true);
      clone.classList.add('gallery-main__crossfade');
      main.appendChild(clone);
      requestAnimationFrame(() => { clone.classList.add('is-visible'); });
      clone.addEventListener('transitionend', () => {
        track.style.transition = 'none';
        index = i;
        track.style.transform = `translateX(-${index * 100}%)`;
        thumbs.forEach((t, ti) => t.classList.toggle('is-active', ti === index));
        slides.forEach((s, si) => {
          const v = s.querySelector('video');
          if (v && si !== index) v.pause();
        });
        void track.offsetWidth;
        track.style.transition = '';
        clone.remove();
      }, { once: true });
    };

    let startX = null;
    main.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) step(dx < 0 ? 1 : -1);
      startX = null;
    });
  });

  // Product form: add to cart
  const form = $('#ProductForm');
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      const submit = form.querySelector('[type=submit]');
      submit.disabled = true; const prev = submit.textContent; submit.textContent = 'A adicionar…';
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('add failed');
        openDrawer();
      } catch { alert('Não foi possível adicionar ao carrinho.'); }
      finally { submit.disabled = false; submit.textContent = prev; }
    });

    // Variant selector
    const variants = JSON.parse($('#ProductVariants')?.textContent || '[]');
    const state = {};
    $$('.option__pill', form).forEach((pill) => {
      pill.addEventListener('click', () => {
        const name = pill.dataset.optionName;
        state[name] = pill.dataset.value;
        const selLabel = pill.closest('.product__option')?.querySelector('[data-option-selected]');
        if (selLabel) selLabel.textContent = ': ' + pill.dataset.value;
        if (['cor', 'color', 'colour'].includes(String(name).toLowerCase())) $('[data-gallery-main]')?.setColor?.(pill.dataset.value);
        // update active
        form.querySelectorAll(`[data-option-name="${name}"]`).forEach((p) => p.classList.toggle('is-selected', p.dataset.value === state[name]));
        // find variant
        const match = variants.find((v) => v.options.every((val, i) => val === state[variants[0].optionNames[i]]));
        if (match) {
          $('#SelectedVariantId').value = match.id;
          $('#ProductPrice').textContent = money(match.price);
          const btn = form.querySelector('[type=submit]');
          btn.disabled = !match.available;
          btn.textContent = match.available ? btn.dataset.addLabel : btn.dataset.soldLabel;
          if (match.featuredMediaId) {
            $('[data-gallery-main]')?.goToMedia?.(match.featuredMediaId);
          }
        }
      });
    });
    // preselect first pill per option
    const optionNames = new Set();
    $$('.option__pill', form).forEach((p) => optionNames.add(p.dataset.optionName));
    optionNames.forEach((n) => form.querySelector(`.option__pill[data-option-name="${n}"]`)?.click());
  }

  // Size guide modal
  $$('[data-modal-open]').forEach((b) => b.addEventListener('click', () => $(`#${b.dataset.modalOpen}`)?.classList.add('is-open')));
  $$('[data-modal-close]').forEach((b) => b.addEventListener('click', () => b.closest('.modal')?.classList.remove('is-open')));

  // Dark mode toggle
  $$('[data-theme-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const next = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
      document.documentElement.setAttribute('data-theme', next);
      try { localStorage.setItem('theme', next); } catch (e) {}
      const m = document.querySelector('meta[name="theme-color"]');
      if (m) m.setAttribute('content', m.getAttribute(next === 'dark' ? 'data-dark' : 'data-light'));
    });
  });

  // Mobile menu
  const mobileMenu = document.getElementById('MobileMenu');
  if (mobileMenu) {
    const mmNav = mobileMenu.querySelector('[data-mobile-menu-nav]');
    const desktopNav = document.querySelector('.site-header__nav');
    if (mmNav && desktopNav && !mmNav.children.length) {
      desktopNav.querySelectorAll('a').forEach((a) => mmNav.appendChild(a.cloneNode(true)));
    }
    const openMM = () => {
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };
    const closeMM = () => {
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    $$('[data-mobile-menu-open]').forEach((b) => b.addEventListener('click', openMM));
    $$('[data-mobile-menu-close]', mobileMenu).forEach((b) => b.addEventListener('click', closeMM));
    if (mmNav) mmNav.addEventListener('click', (e) => { if (e.target.closest('a')) closeMM(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) closeMM();
    });
  }

  // Initial cart count
  refreshCart();


  // FAQ page: pesquisa e destaque da categoria na barra lateral
const faqSearch = document.querySelector('[data-faq-search]');
if (faqSearch) {
  const faqEmpty = document.querySelector('[data-faq-empty]');
  faqSearch.addEventListener('input', () => {
    const term = faqSearch.value.trim().toLowerCase();
    let anyCatVisible = false;
    $$('[data-faq-category]').forEach((cat) => {
      let anyVisible = false;
      cat.querySelectorAll('[data-faq-item]').forEach((item) => {
        const match = term === '' || item.textContent.toLowerCase().includes(term);
        item.classList.toggle('is-hidden', !match);
        if (match) anyVisible = true;
      });
      cat.classList.toggle('is-hidden', !anyVisible);
      if (anyVisible) anyCatVisible = true;
    });
    if (faqEmpty) faqEmpty.style.display = anyCatVisible ? 'none' : 'block';
  });
}
$$('[data-faq-nav]').forEach((link) => {
  link.addEventListener('click', () => {
    $$('[data-faq-nav]').forEach((l) => l.classList.remove('is-active'));
    link.classList.add('is-active');
  });
});
// 

// FAQ: animação suave a abrir/fechar as perguntas
class FaqAccordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('[data-faq-answer]');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }
  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }
  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 260, easing: 'ease-out' });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => { this.isClosing = false; };
  }
  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 260, easing: 'ease-out' });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => { this.isExpanding = false; };
  }
  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}
$$('.faq-item').forEach((el) => new FaqAccordion(el));




})();

